/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconRss({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconRss">  <path fill="currentColor" d="M44 75.5v-34c97 0 175.6 78.6 175.6 175.6h-34C185.5 138.8 122.2 75.5 44 75.5zm74.3 138.8c0 .9 0 1.8-.1 2.7h33.3v-2.7c0-58.3-47.3-105.6-105.6-105.6H44V142h1.9c40 0 72.4 32.4 72.4 72.3zM84.9 217c0-.8.1-1.5.1-2.3 0-21.4-17.3-38.7-38.7-38.7-.8 0-1.6 0-2.3.1V217h40.9z" /></svg>
  );
}

IconRss.propTypes = iconPropTypes;
IconRss.defaultProps = iconDefaultProps;
